// src/utils/hyrosTracker.js
export const trackHyrosEvent = (
  eventName: string,
  value = 0,
  metadata = {}
) => {
  if (window.hyr) {
    window.hyr("track", eventName, {
      value: value,
      ...metadata,
    });
    console.log(`Hyros event tracked: ${eventName}`, { value, metadata });
    return true;
  } else {
    console.warn("Hyros tracker not available");
    return false;
  }
};

// src/utils/metaPixel.js
export const trackPixelEvent = (event, options = {}) => {
  if (window.fbq) {
    window.fbq("track", event, options);
  } else {
    console.warn("Meta Pixel not loaded yet or blocked");
  }
};
